module.exports = "<app-navbar></app-navbar>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /mnt/d/Projects/angular/chisparural-foro/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 1